import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import { ledgerAPI } from '../../services/api';
import ModulePageHeader from '../common/ModulePageHeader';
import InvoicesTab from './receivables/InvoicesTab';
import PaymentsTab from './receivables/PaymentsTab';
import { AgingReportView } from './receivables/ArReportsTab';
import FeeSyncPanel from './receivables/FeeSyncPanel';

const invoicesApi = {
  list: ledgerAPI.getFeeInvoices,
  get: ledgerAPI.getFeeInvoice,
  create: ledgerAPI.createFeeInvoice,
  approve: ledgerAPI.approveFeeInvoice,
  post: ledgerAPI.postFeeInvoice,
  void: ledgerAPI.voidFeeInvoice,
  remove: ledgerAPI.deleteFeeInvoice,
};

const paymentsApi = {
  list: ledgerAPI.getFeePayments,
  get: ledgerAPI.getFeePayment,
  create: ledgerAPI.createFeePayment,
  approve: ledgerAPI.approveFeePayment,
  post: ledgerAPI.postFeePayment,
  void: ledgerAPI.voidFeePayment,
  remove: ledgerAPI.deleteFeePayment,
};

const TABS = [
  { value: 'invoices', label: 'Invoices' },
  { value: 'payments', label: 'Payments' },
  { value: 'aging', label: 'Aging' },
];

// Fees & Billing: the day-to-day billing/collection screen for front-desk
// and bursar staff - same accounts-receivable/invoices + /payments + aging
// endpoints as Student Receivables' Invoices/Payments/Aging, reused as-is
// (see InvoicesTab.js/PaymentsTab.js's resource/api props), but reached
// through the Laravel gateway's 'fees' section and gated under the lighter
// RESOURCES.LEDGER.FEES permission - see config/ledger.php. Distinct from
// Student Receivables (ledger-receivables), which additionally covers
// provisions/write-offs/recoveries/full AR reporting for accountants.
const FeesBilling = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('invoices');

  if (!can(RESOURCES.LEDGER.FEES, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Fees &amp; Billing.</Alert>;
  }

  return (
    <Box>
      <ModulePageHeader
        title="Fees & Billing"
        subtitle="Bill students and collect fee payments - synced with the school's fee collection flow"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)}>
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {tab === 'invoices' && (
        <>
          <FeeSyncPanel />
          <InvoicesTab resource={RESOURCES.LEDGER.FEES} api={invoicesApi} />
        </>
      )}
      {tab === 'payments' && (
        <PaymentsTab resource={RESOURCES.LEDGER.FEES} api={paymentsApi} listInvoices={ledgerAPI.getFeeInvoices} />
      )}
      {tab === 'aging' && <AgingReportView fetchAging={ledgerAPI.getFeeAgingReport} />}
    </Box>
  );
};

export default FeesBilling;
